<template>
  <div v-if="show" class="card-traffic">
    <div class="traffic_datepicker" >

      <fg-input class="mx-input"
        type='datepicker'
        v-model="cur_date"
        :range="true"
        format="DD-MM-YYYY"
        :disabled-date="disabledDate"
      />

      <div class="filter">
        <div class="info">
          {{this.translate('use_utc_time')}}
        </div>
        <label class="switch" @click.prevent="filters.use_utc_time = !filters.use_utc_time">
          <input type="checkbox" v-model="filters.use_utc_time">
          <span class="slider round"></span>
        </label>
      </div>

      <div class="filter">
        <div class="info">
          {{this.translate('all_ifaces')}}
        </div>
        <label class="switch" @click.prevent="filters.all_ifaces = !filters.all_ifaces">
          <input type="checkbox" v-model="filters.all_ifaces">
          <span class="slider round"></span>
        </label>
      </div>

      <button
        class="mdi btn btn-info"
        :class="{ 'mdi-content-save': !loading }"
        @click.prevent="save_traffic"
        :disabled="loading"
      >
        <scale-loader v-if="loading" height='9.5px' width='13.5px' margin='2px 2px 1px 2px'/>
        <span v-else> {{ translate('save') }} </span>

      </button>

      <button class="mdi btn btn-info" @click.prevent="cur_month">
        <span> {{ translate('cur_month') }} </span>
      </button>

      <button class="mdi btn btn-info" @click.prevent="last_month">
        <span> {{ translate('last_month') }} </span>
      </button>
    </div>

    <div v-if="tr.length <= 1" style="height: 100%">
      <h1 style="text-align: center" >
        {{translate('no_data')}}
      </h1>
    </div>

    <div v-else
      ref="header"
      class="row response_table3"
    >
      <table
        ref="tabl"
        style="display: table; height: auto"
        @scroll="scroll"
      >
        <thead>
          <tr>
            <th
              rowspan="2"
              class="traffic_block"
            >
              {{ translate('date.one') }}
            </th>
            <th
              v-for="(item,index) in th"
              :key="index"
              colspan="3"
              class="traffic_block"
            >
              <div v-if="item.type===0">
                {{ item.name + (item.imsi?'('+item.imsi+')':'') }}
              </div>
              <div v-else>
                <span class="sphere" :style="'background-color:'+item.color" />
                {{ item.name + ' ' + (item.imsi?'('+item.imsi+')':'') + (item.slot? '(' + item.slot + ')' : '') }}
                <span v-if="+item.active === 1" class="mdi mdi-check-circle-outline" title="In device"></span>
                <span v-else class="mdi mdi-checkbox-blank-circle-outline" title="Not in device"></span>
              </div>
            </th>
          </tr>
          <tr>
            <template v-for="(item,key) in th">
              <th :key="key+'rx'">
                rx
              </th>
              <th :key="key+'tx'">
                tx
              </th>
              <th :key="key+'sum'"
                  class="traffic_block"
              >
                Sum
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, indx2) in tr"
            :key="indx2"
          >
            <td
              v-for="(item2,index) in item"
              :key="index"
              :class="{traffic_block:(index%3===0)}"
            >
              {{ item2 }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    v-else
    style="height: 100%"
  >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>
</template>

<script>


export default {
  name: 'Traffic',
  props: {
    dev_id: {
      type: [Number, String],
      default: null
    },
    simcard_list: {
      type: [Array, Object],
      default: () => []
    },
  },
  data () {
    let today = new Date().setHours(0, 0, 0, 0)
    let start = (new Date(today).setDate(new Date(today).getDate() - 6) / 1000)
    let end = (new Date(today).setHours(23, 59, 59, 0) / 1000)

    return {
      loading: false,
      show: false,
      th: [],
      tr: [],
      today: today,
      date_end: end,
      date_start: start,
      cur_date: [''+start,''+end],
      filters:{
        use_utc_time: true,
        all_ifaces: false
      }
    }
  },

  watch: {
    dev_id () {
      this.get_traffic()
    },
    cur_date () {
      if (this.cur_date.length > 1) {
        this.date_start = +this.cur_date[0]
        this.date_end = +this.cur_date[1]
        this.get_traffic()
      }
    },
    'filters.use_utc_time':{
      handler: function () {
        this.get_traffic()
      },
    },
    'filters.all_ifaces':{
      handler: function () {
        this.get_traffic()
      },
    },
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },

  mounted () {
    this.get_traffic()
  },

  computed:{
    datetime_picker(){
      return this.$store.getters.getDatetimePicker
    }
  },
  methods: {
    cur_month(){
      this.date_end = (new Date(this.today).setHours(23, 59, 59, 0) / 1000)
      this.date_start = (new Date(this.today).setDate(1) / 1000)
      this.cur_date = [''+this.date_start, ''+this.date_end]
    },

    last_month(){
      this.date_end = (new Date(this.today).setHours(23, 59, 59, 0) / 1000)
      this.date_start = (new Date(this.today).setMonth(new Date(this.today).getMonth() - 1) / 1000)
      this.cur_date = [''+this.date_start, ''+this.date_end]
    },

    find_sim_by_imsi(imsi){
      for (let simcard of this.simcard_list) {
        if (simcard.imsi === imsi) {
          return simcard
        }
      }
    },

    disabledDate(date) {
      let today = new Date();
      return date > new Date(today.getTime()) || date < new Date(today.getTime() - this.datetime_picker * 24 * 3600 * 1000);
    },

    scroll (event) {
      this.$refs.header.scrollTo(event.target.scrollLeft, 0)
    },

    save_traffic () {
      this.loading = true;
      let params = {
        dev_id: this.dev_id,
        date_start: this.date_start,
        date_end: this.date_end,
        utc: this.filters.use_utc_time,
        csv: true,
        all_ifaces: this.filters.all_ifaces
      }
      this.$http.v1.getDeviceTrafficcsv(params ,  (response) => {
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let date1 = new Date(this.date_start*1000)
        let date2 = new Date(this.date_end*1000)
        link.download = 'Traffic' + '_' + this.dev_id + '_' + date1.getDate() + '.' + (date1.getMonth() + 1) + '.' + date1.getFullYear() + '—' + ((+date2 !== 0) ? + date2.getDate() + '.' + (date2.getMonth() + 1) + '.' + date2.getFullYear() : '') + '.csv'
        link.click()
        this.loading = false
      })
    },

    get_traffic () {
      if (this.$route.name === 'device_section') {
        this.show = false
        let params = {
          dev_id: this.dev_id,
          date_start: this.date_start,
          date_end: this.date_end,
          utc: this.filters.use_utc_time,
          csv: false,
          all_ifaces: this.filters.all_ifaces
        }
        this.$http.v1.getDeviceTraffic(params, (response) => {
          this.show = true
          let th = []
          let iface = []

          let name_iface = []

          for( let i in response.data.ifaces) {
              name_iface.push(i);
          }

          name_iface.sort();

          for (let i in name_iface) {
            th.push({type: 0, name: name_iface[i]})
            iface.push(name_iface[i])
          }

          for (let i in response.data.simcards) {
            let sim_info = response.data.simcards[i]
            sim_info.type = 1
            sim_info.name = response.data.simcards[i].mno

            if (this.find_sim_by_imsi(sim_info.imsi)?.sim_state) {
              sim_info.color = this.find_sim_by_imsi(sim_info.imsi).sim_state.color
            }

            th.push(sim_info)
            iface.push(i)
          }
          this.th = th

          let tr = []
          let tdDate = []
          let td = []

          let traffics = Object.keys(response.data.traffic).sort()
          for (var i in traffics) {
            td = []
            tdDate.push(traffics[i])
            td.push(traffics[i])
            for (let j in iface) {
              if ((response.data.traffic[traffics[i]] !== null && response.data.traffic[traffics[i]][iface[j]] !== undefined)) {
                td.push((+response.data.traffic[traffics[i]][iface[j]].rx).toFixed(2))
                td.push((+response.data.traffic[traffics[i]][iface[j]].tx).toFixed(2))
                td.push((response.data.traffic[traffics[i]][iface[j]].rx + response.data.traffic[traffics[i]][iface[j]].tx).toFixed(2))
              } else {
                td.push('null')
                td.push('null')
                td.push('null')
              }
            }
            tr.push(td)
          }
          this.tr = tr
        })
      }
    }
  }
}

</script>

<style lang='scss' scoped>
.traffic_block{
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      margin: 0 3px;
    }
    .mdi{
      font-size: 16px;
    }
  }

}

.scale-loader {
  height: 9px;
  width: 9px;
  margin: 4px;
}

.card-traffic {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  .traffic_datepicker {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 0;

    .btn{
      width: 15%;
      min-height: 40px;
      margin-right: 10px;
      :last-child{
        margin-right: 0;
      }
      span{
        white-space: pre-line;
      }
    }

    .mx-icon-calendar {
      display: none;
    };

    .mx-icon-clear {
      display: none;
    };

    .form-group {
      width: 360px;
      margin-right: 10px;
      margin-bottom: 0;
    }

    .filter{
      display: flex;
      justify-content: center;
      align-items: center;
      // flex-direction: column;
      min-width: 150px;
      margin-right: 10px;

      .info{
        margin-right: 5px;
        text-transform: full-width;
        min-inline-size: max-content;
      }

      .select{
        margin: 0;
        width: 120px;
      }

      .switch {
        position: relative;
        display: inline-block;
        width: 45px;
        height: 22px;
        margin-bottom: 0;
      }
      .switch input {
        display:none;
      }
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
      }

      .slider:before {
        position: absolute;
        content: "";
        height: 16px;
        width: 16px;
        left: 6px;
        bottom: 3px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
      }

      input:checked + .slider {
        background-color: #41B883;
      }

      input:focus + .slider {
        box-shadow: 0 0 1px #41B883;
      }

      input:checked + .slider:before {
        transform: translateX(18px);
      }

      .slider.round {
        border-radius: 34px;
      }

      .slider.round:before {
        border-radius: 50%;
      }
    }
  }
}

@media (max-width:750px){
  .card-traffic .traffic_datepicker{
    flex-wrap: wrap;
    .form-group{

    }
    .btn{
      width: 30%;
      margin: 5px;
    }
  }
}
 </style>
